var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResolutionSpecificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.851697 4.00353H0V0.364059C0 0.163659 0.163659 0 0.364059 0H2.90356V0.852811H0.851697V4.00353ZM4.3431 10.816H0.364059C0.162546 10.816 0 10.6523 0 10.4497V6.29143H4.3431V10.816ZM5.9886 0.842791V0H8.92111V0.842791H5.9886ZM11.0966 0H13.3165C13.5181 0 13.6806 0.163659 13.6806 0.364059V4.00799H12.8289V0.842791H11.0966V0ZM13.6806 6.35377V10.4508C13.6806 10.6523 13.5169 10.8149 13.3165 10.8149H11.0966V9.9643H12.8311C12.8311 8.87212 12.8311 7.44706 12.8311 6.35377H13.6806ZM8.92222 10.816H5.98415V9.9643H8.92222V10.816Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResolutionSpecificationIcon);
export default __webpack_public_path__ + "static/media/resolution_specification_icon.9722040d02a41f5b8db8defaffe80e17.svg";
export { ForwardRef as ReactComponent };